import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Segment } from '../../models/onboarding/onboarding.model';
import { API_URLS } from '../../constants/api-urls/api-urls';
import { skipSpinnerOptions } from '../../core/services/http-options.utils';


@Injectable({
  providedIn: 'root'
})
export class OnboardingApiService {

  constructor(
    private http: HttpClient,
  ) { }

  getSegments(): Observable<any> {
    return this.http.get(API_URLS.ONBOARDING.SEGMENTS, skipSpinnerOptions());
  }
  raiseAccessRequest(params: { wwid: number | string, user_name: string, user_email: string, region: string, business_unit_code: string, is_manual_request?: boolean }): Observable<any> {
    const { wwid, user_name, user_email, region, business_unit_code } = params;
    const url = `${API_URLS.ONBOARDING.ACCESS_REQUEST}${wwid}?user_name=${encodeURIComponent(user_name)}&user_email=${encodeURIComponent(user_email)}&region=${encodeURIComponent(region)}&business_unit_code=${encodeURIComponent(business_unit_code)}&is_manual_request=${params.is_manual_request}`;
    return this.http.post(url, null, skipSpinnerOptions());
  }

  getUserProfile(wwid: number | string): Observable<any> {
    const payload = { wwid: Number(wwid), role_code: [] };
    return this.http.post(`${API_URLS.ONBOARDING.USER_PROFILE}`, payload, skipSpinnerOptions());
  }
}
